module.exports = __webpack_public_path__ + "static/media/7-15.185bd315.mp3";